import { useMemo } from 'react'
import Link from 'next/link'
import styles from './SubCategoryCard.module.scss'
import { SubCategoryCardProps } from './types'
import { routes } from 'utils/routes'
import { Heading } from '@boltenergy-be/design-system'

const SubCategoryCard = ({ subCategory, color }: SubCategoryCardProps) => {
  // Category useMemo
  const category = useMemo(() => subCategory.category, [subCategory.category])

  const destination = useMemo(
    () => routes(subCategory.locale, undefined, [category.slug, subCategory.slug]).encyclopediaSubCategory,
    [subCategory, category]
  )

  return (
    <div className={styles['card-wrapper']}>
      <Link href={destination} prefetch={false} className={styles['sub-category-card']}>
        <Heading as="h3" variant="h5">
          {subCategory.title}
        </Heading>
      </Link>
      <div className={styles.bg} style={{ backgroundColor: color }} />
    </div>
  )
}

export default SubCategoryCard
